import { render, staticRenderFns } from "./NameInput.vue?vue&type=template&id=509e04dc"
import script from "./NameInput.vue?vue&type=script&lang=js"
export * from "./NameInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports